<template>
  <section class="hero-subsection" aria-labelledby="contact-hero-title">
    <div class="hero-shell">
      <div class="hero-content">
        <h1 id="contact-hero-title" class="hero-title">Contactez-nous</h1>
        <p class="hero-description">
          Notre équipe est là pour répondre à toutes vos questions. N'hésitez pas à nous contacter&nbsp;!
        </p>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HeroSubsection",
});
</script>

<style>
.hero-subsection {
  align-self: stretch;
  background: linear-gradient(135deg, #fafafa 0%, #f7fcf3 100%);
  padding: clamp(52px, 7vw, 88px) clamp(16px, 4vw, 30px);
  width: 100%;
}

.hero-subsection .hero-shell {
  margin: 0 auto;
  max-width: 1200px;
}

.hero-subsection .hero-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: clamp(14px, 2.4vw, 24px);
  margin: 0 auto;
  max-width: 860px;
  text-align: center;
}

.hero-subsection .hero-title {
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: clamp(1.9rem, 5.2vw, 3rem);
  font-weight: 700;
  line-height: 1.1;
  margin: 0;
  text-wrap: balance;
}

.hero-subsection .hero-description {
  color: #5f5f5f;
  font-family: "Poppins", Helvetica;
  font-size: clamp(1rem, 2.1vw, 1.12rem);
  font-weight: 400;
  line-height: 1.6;
  margin: 0;
  max-inline-size: 68ch;
}
</style>
